<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface BaseLayerLogo {
  src: string
  name: string
}

export interface BaseLayerProps {
  layers: BaseLayerLogo[]
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { AvatarGroup, AvatarGroupOverflow } from '#ui-kit/ui/avatar'
import { Tooltip, TooltipContent, TooltipTrigger } from '#ui-kit/ui/tooltip'
import { ProjectAvatar } from '#ui-kit/blocks/avatars'

const props = defineProps<BaseLayerProps>()

const MAX_VISIBLE = 5

const visible = computed(() => props.layers.slice(0, MAX_VISIBLE))
const hidden = computed(() => props.layers.slice(MAX_VISIBLE))
const hiddenNames = computed(() => hidden.value.map((layer) => layer.name).join(', '))
</script>

<template>
  <div
    data-slot="base-layer"
    :class="
      cn(
        'inline-flex h-10 items-center gap-2 rounded-full border border-gray-600/30 bg-gray-600/10 px-3 text-gray-600',
        props.class,
      )
    "
  >
    <span class="truncate font-mono text-xs font-medium">Token Base layer</span>
    <AvatarGroup v-if="props.layers.length">
      <Tooltip v-for="layer in visible" :key="layer.name">
        <TooltipTrigger as-child>
          <ProjectAvatar :src="layer.src" :alt="layer.name" bordered class="bg-black" tabindex="0" />
        </TooltipTrigger>
        <TooltipContent>{{ layer.name }}</TooltipContent>
      </Tooltip>
      <Tooltip v-if="hidden.length">
        <TooltipTrigger as-child>
          <AvatarGroupOverflow :count="hidden.length" :aria-label="hiddenNames" tabindex="0" />
        </TooltipTrigger>
        <TooltipContent>{{ hiddenNames }}</TooltipContent>
      </Tooltip>
    </AvatarGroup>
  </div>
</template>
